import { render, staticRenderFns } from "./UserIntegral.vue?vue&type=template&id=2d7de418&scoped=true"
import script from "./UserIntegral.vue?vue&type=script&lang=js"
export * from "./UserIntegral.vue?vue&type=script&lang=js"
import style0 from "./UserIntegral.vue?vue&type=style&index=0&id=2d7de418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7de418",
  null
  
)

export default component.exports